import type { CSSProperties } from 'react';

/**
 * The design-system `:root` tokens, re-declared inline. Applied as a `style` on
 * the legal layout wrapper so legal pages always render in the neutral Meitre
 * palette (warm cream + gold) — even when opened on a themed restaurant host,
 * where `useRestaurantTheme` injects a `<style id="restaurant-theme">`. Inline
 * CSS variables beat an injected stylesheet, so this guarantees neutral.
 *
 * Mirrors `src/index.css` `:root`. Keep in sync if the base tokens change.
 */
export const MEITRE_NEUTRAL_VARS = {
  '--background': '40 38% 100%',
  '--foreground': '40 10% 10%',
  '--card': '0 0% 100%',
  '--card-foreground': '240 10% 3.9%',
  '--primary': '34.8 34.5% 48%',
  '--primary-foreground': '0 0% 100%',
  '--primary-dark': '34.2 30.8% 38%',
  '--secondary': '40 5% 96%',
  '--muted': '40 5% 96%',
  '--muted-foreground': '40 3.8% 46.1%',
  '--accent': '40 5% 96%',
  '--border': '40 5.9% 90%',
  '--input': '40 5.9% 90%',
  '--ring': '40 5.9% 50%',
} as unknown as CSSProperties;
